// extracted by mini-css-extract-plugin
module.exports = {"button":"SalarisButton-button-b27d"};